module.exports = __webpack_public_path__ + "static/amr-08f5c57d933e8ea3b4add11d252e4a51.jpg";